<template>
  <form-group v-if="mercadoLivreAccounts.length" :columns="12" label="Conta">
    <select class="form-select" v-model="account">
      <option value="">Selecione</option>
      <option v-for="account in mercadoLivreAccounts" :key="account.identifier" :value="account.identifier">
        {{ account.name }} ({{ account.nickname }})
      </option>
    </select>
  </form-group>
</template>

<script>
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      account: '',
      mercadoLivreAccounts: []
    }),
    async mounted () {
      this.mercadoLivreAccounts = (await api.mercadoLivre.getAccounts({})).items
    },
    methods: {
      async syncOrder (data) {
        await api.mercadoLivre.syncOrder(data.type, data.identifier, data.code, this.account)
      }
    },
    components: {
      FormGroup
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SyncDialog.vue?76a20c8d